interface Props {
  width?: string;
  height?: string;
  stroke?: string;
  className: string;
}

const Trainings = ({
  width = '48',
  height = '48',
  stroke = '#1a1818',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g>
      <path
        fill="none"
        stroke={stroke}
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeOpacity="1"
        strokeWidth="0.529"
        d="M10.573 7.364a1.576 1.576 0 00-.388-1.11 1.489 1.489 0 00-1.113-.518c-.787 0-1.444.671-1.496 1.529a.174.174 0 01-.134.164.163.163 0 01-.18-.102c-.261-.627-.921-1.05-1.645-1.05-.611 0-1.17.29-1.497.774a.158.158 0 01-.174.067.177.177 0 01-.12-.154c-.048-.487.048-1.351.78-2.703a.161.161 0 01.141-.088h.838l.37-.378a1.085 1.085 0 00-.318-.736 3.931 3.931 0 00-.664-.07c-.291 0-.384.06-.405.078-.003.007-1.898 2.308-2.43 4.315-.05.192.05.716.19.833.562.465 1.733 1.278 3.204 1.416.552.053 1.063.08 1.518.08 3.007 0 3.47-1.128 3.523-2.347z"
        opacity="1"
      />
    </g>
  </svg>
);

export default Trainings;
